import React, { useContext, useEffect } from "react"
import PropTypes from "prop-types"
import { useNavigate, Navigate } from "react-router-dom"
import i18n from "i18n"
import * as amplitude from "@amplitude/analytics-browser"

import AuthContext from "context/auth/authContext"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  navContent: navContent,
  ...rest
}) => {
  const { user, showSnackbar, form } = useContext(AuthContext)
  const navigate = useNavigate()

  const changeLanguage = lang => {
    lang = "ES" // Override until translations are added
    i18n.changeLanguage(lang)
  }

  useEffect(() => {
    console.log(`user = ${JSON.stringify(user)}`)
    if (isAuthProtected && user) {
      amplitude.setUserId(user.email)
      const identifyEvent = new amplitude.Identify()
      identifyEvent.set("subscription_plan", user["custom:subscription_plan"])
      identifyEvent.set(
        "subscription_status",
        user["custom:subscription_status"],
      )
      amplitude.identify(identifyEvent)
      if (user["custom:onboarding"] !== "true") {
        if (form == false) {
          return navigate("/onboarding")
        }
      }

      if (user["custom:idioma"]) {
        changeLanguage(user["custom:idioma"])
      } else {
        i18n.changeLanguage("ES")
      }
    }
  }, [user])

  return (
    <>
      {isAuthProtected && !localStorage.getItem("userAuth") ? (
        <Navigate to="/login" replace />
      ) : (
        <Layout navContent={navContent}>
          <Component {...rest} />
        </Layout>
      )}
    </>
  )
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  navContent: PropTypes.any,
}

export default Authmiddleware
